/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareGamificationModelBody
 */
export interface ShareGamificationModelBody {
    /**
     * Platform the model was shared to
     * @type {string}
     * @memberof ShareGamificationModelBody
     */
    platform: ShareGamificationModelBodyPlatformEnum;
}


/**
 * @export
 */
export const ShareGamificationModelBodyPlatformEnum = {
    TWITTER: 'TWITTER',
    DISCORD: 'DISCORD',
    COPY_LINK: 'COPY_LINK'
} as const;
export type ShareGamificationModelBodyPlatformEnum = typeof ShareGamificationModelBodyPlatformEnum[keyof typeof ShareGamificationModelBodyPlatformEnum];


/**
 * Check if a given object implements the ShareGamificationModelBody interface.
 */
export function instanceOfShareGamificationModelBody(value: object): value is ShareGamificationModelBody {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function ShareGamificationModelBodyFromJSON(json: any): ShareGamificationModelBody {
    return ShareGamificationModelBodyFromJSONTyped(json, false);
}

export function ShareGamificationModelBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareGamificationModelBody {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
    };
}

export function ShareGamificationModelBodyToJSON(json: any): ShareGamificationModelBody {
    return ShareGamificationModelBodyToJSONTyped(json, false);
}

export function ShareGamificationModelBodyToJSONTyped(value?: ShareGamificationModelBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
    };
}

